module.exports = __webpack_public_path__ + "static/img/2-9-错发换货.95ad519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-9-错发换货.png
// module id = 1321
// module chunks = 0